import React from 'react';
import PropTypes from 'prop-types';
import { FontIcon } from 'react-toolbox';
import Loading from 'components/Loading';
import S from './styles.scss';

const TaskIcon = ({ status }) => {
  switch (status) {
    case 'complete':
      return (<FontIcon className={S.taskCheckedIcon} value="check_circle" />);
    case 'pending':
      return (<Loading size="24" radius="10" />);
    default:
      return (<FontIcon className={S.taskClockIcon} value="access_time" />);
  }
};

TaskIcon.defaultProps = {
  status: 'incomplete',
};

TaskIcon.propTypes = {
  status: PropTypes.oneOf(['complete', 'pending', 'incomplete']),
};

export default TaskIcon;



// WEBPACK FOOTER //
// ./client/app/shared/components/TaskIcon/index.jsx